import type { StartInfo } from '../api/client';
import type { T } from '../i18n';

/** The privacy level, derived from the survey's settings — never declared (IDEA.md principle 6). */
export function PrivacyLine({ level, t }: { level: StartInfo['privacyLevel']; t: T }) {
  return (
    <div class="privacy">
      <strong>{t(`privacy.${level}`)}</strong>
    </div>
  );
}
